import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootState';
import { Dialog } from '../../../store/appState';
import { AuthenticationMessages } from '../Submission/Notifications';
import { ChildrenProps } from '../../../utils/types';
import styled from 'styled-components/macro';
import * as Actions from '../../../store/actions';
import ActivityList from './ActivityList';
import { SignInState } from '../../../app';

export interface MyActivityViewProps {
}

export default function MyActivityView(props: MyActivityViewProps): JSX.Element {
    const state = useSelector((state: RootState) => state.appState);

    useEffect(() => {
        Actions.setDialog(Dialog.none);
    }, []);

    const signinState: number = state.signInState;

    return <Wrapper data-cy="rap-submit-post-view" className="top-level-text">
        {<AuthenticationMessages
            signinState={signinState}
            signInErrorMessage={state.signInErrorMessage}
            render={(props: ChildrenProps) => <PageContent>{props.children}</PageContent>} />
        }

        {signinState === SignInState.Success && <>
            <PageContent>
                <ActivityList />
            </PageContent>
        </>}
    </Wrapper>
}

const Wrapper = styled.div`
    background-color: var(--color-background);
`;

const PageContent = styled.main`
    min-height: 60vh;
    margin-left: auto;
    margin-right: auto;
    padding: 3.5rem var(--page-margin-horizontal);

    >* + * {
        margin-top: 2.5rem;
    }

    .title-instruction {
        font-size: 1.8rem;
        line-height: 2.4rem;
        font-weight: 350;

        .btn-link {
            padding: 0;
            height: auto;
        }
    }

    .selected-post-header.collapsed {
        background-color: var(--color-secondary);
    }

    .selected-post-header {
        font-size: 2.4rem;
    }
`;

